'use client'

import { cn } from '../../utils/cn'

interface GridBackgroundProps {
  variant?: 'grid' | 'dot'
  className?: string
}

export function GridBackground({
  variant = 'grid',
  className
}: GridBackgroundProps) {
  return (
    <div
      className={cn(
        'absolute inset-0 pointer-events-none',
        variant === 'grid' ? 'grid-pattern' : 'dot-pattern',
        'opacity-30',
        className
      )}
      aria-hidden="true"
    />
  )
}
